<template>
  <BaseCardSection title="Nahrání obrázků" :is-visible="true" :is-optional="false" :is-collapsible="true">

    <div class="picture-picker">
      <div class="row">
        <div class="col-12">
          <!-- Upload form -->
          <div v-if="pictures.length < MAX_PICTURES" class="mb-4">
            <PictureUploadForm
                @upload="handleUpload"
                :is-uploading="isUploading"
            />
          </div>

          <!-- Pictures limit info -->
          <div class="mb-3">
            <small class="text-muted">
              Nahráno {{ pictures.length }}/{{ MAX_PICTURES }} obrázků
            </small>
          </div>

          <!-- Pictures grid -->
          <div v-if="pictures.length > 0" class="row g-3">
            <div
                v-for="picture in pictures"
                :key="picture.id"
                class="col-lg-4 col-md-6 col-12"
            >
              <PictureCard
                  :picture="picture"
                  @delete="handleDelete"
              />
            </div>
          </div>

          <!-- Empty state -->
          <div v-else class="text-center py-5">
            <i class="bi bi-images fs-1 text-muted"></i>
            <p class="text-muted mt-2">Zatím nejsou nahrány žádné obrázky</p>
          </div>
        </div>
      </div>
    </div>
  </BaseCardSection>
</template>

<script setup>
import {ref, defineExpose, defineProps, onMounted} from 'vue'
import PictureUploadForm from '@/components/pictures/PictureUploadForm.vue'
import PictureCard from '@/components/pictures/PictureCard.vue'
import api from "@/api/api";
import myApi from "@/api/api";
import BaseCardSection from "@/components/base/BaseCardSection.vue";
// import { uploadPicture } from '@/api/api.js' // Bude doplněno později

const MAX_PICTURES = 10
const MAX_FILE_SIZE = 6 * 1024 * 1024 // 6MB in bytes

const pictures = ref([])
const isUploading = ref(false)
const props = defineProps({cid: String})

const handleUpload = async (uploadData) => {
  try {
    isUploading.value = true

    // Validace
    if (!validateFile(uploadData.file)) {
      return
    }
    const response = await uploadAttachment(uploadData);
    // Přidání obrázku do seznamu
    const newPicture = {
      id: response.id,
      description: response.description,
      thumbnailUrl: response.url_thumbnail,
      fullImageUrl: response.url,
      filename: response.file_name,
      size: response.file_size,
      uploadedAt: response.created_at
    }

    pictures.value.push(newPicture)

  } catch (error) {
    console.error('Chyba při nahrávání obrázku:', error)
    alert('Chyba při nahrávání obrázku. Zkuste to prosím znovu.')
  } finally {
    isUploading.value = false
  }
}

const handleDelete = async (pictureId) => {
  await myApi.deleteAttachment(pictureId);
  const index = pictures.value.findIndex(p => p.id === pictureId)
  if (index !== -1) {
    pictures.value.splice(index, 1)
  }
}

const validateFile = (file) => {
  // Kontrola typu souboru
  const allowedTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/bmp',
    'image/tiff',
    'image/tif',
  ]
  const isValidType = allowedTypes.some(type => file.type.includes(type) || file.type === type)

  if (!isValidType) {
    alert('Povolené jsou pouze JPG, PNG, BMP a TIFF obrázky.')
    return false
  }

  // Kontrola velikosti
  if (file.size > MAX_FILE_SIZE) {
    alert('Maximální velikost obrázku je 6MB.')
    return false
  }

  // Kontrola počtu obrázků
  if (pictures.value.length >= MAX_PICTURES) {
    alert(`Maximální počet obrázků je ${MAX_PICTURES}.`)
    return false
  }

  return true
}

const uploadAttachment = async (uploadData) => {
  const result = await api.uploadAttachment(uploadData.file, uploadData.description, props.cid)
  console.log(result)
  return result
}

onMounted(async () => {
  const pictures_list = await myApi.listAttachments(props.cid)
  pictures_list.forEach(picture => {
    const newPicture = {
      id: picture.id,
      description: picture.description,
      thumbnailUrl: picture.url_thumbnail,
      fullImageUrl: picture.url,
      filename: picture.file_name,
      size: picture.file_size,
      uploadedAt: picture.created_at
    }

    pictures.value.push(newPicture)
  })
})


// Export pro parent komponentu
defineExpose({
  getPictures: () => pictures.value,
  clearPictures: () => pictures.value = []
})
</script>

<style scoped>
.picture-picker {
  padding: 1rem;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  background-color: #f8f9fa;
}
</style>